/**
 * Ask Salah read APIs — subscription state from sal-core; token/session helpers on sal-api.
 */
import { get } from '../index';
import {
  checkAskSalahTrialEligibility,
  fetchActiveAskSalahSubscription,
} from './coreSubscription';
import type {
  AskSalahSubscription,
  AskSalahTrialEligibility,
  AskSalahSessionUsage,
} from 'src/types/askSalah';

/**
 * Get user's current Ask Salah subscription (sal-core)
 */
export const getUserAskSalahSubscription = (
  locale?: string,
): Promise<AskSalahSubscription | null> =>
  fetchActiveAskSalahSubscription(locale);

/**
 * Check if user is eligible for Ask Salah free trial (sal-core history)
 */
export const checkTrialEligibility = (
  locale?: string,
): Promise<AskSalahTrialEligibility> =>
  checkAskSalahTrialEligibility(locale);

/**
 * Get session usage statistics (sal-api reads sal-core metadata when configured)
 */
export const getSessionUsage = (): Promise<AskSalahSessionUsage> =>
  get<AskSalahSessionUsage>('/ask-salah/sessions/usage');

/**
 * Check free trial session consumption from Ask Salah external API (sal-api proxy)
 */
export const checkFreeTrialSessions = (): Promise<{
  status: 'success' | 'error';
  data?: {
    email: string;
    session_limit: number;
    session_used: number;
    session_remaining: number;
    subscription_type: string;
  };
  message?: string;
}> => get<{
  status: 'success' | 'error';
  data?: {
    email: string;
    session_limit: number;
    session_used: number;
    session_remaining: number;
    subscription_type: string;
  };
  message?: string;
}>('/ask-salah/check-free-trial-sessions');

export {
  fetchAskSalahQuotations,
  mapCorePlanToAskSalahQuotation,
} from './coreSubscription';
